import {action, computed, observable, transaction, makeObservable} from 'mobx'
import {BulkEditPropertyProps} from './BulkEditDialogProperties'

export class BulkEditDialogState {
    @observable public dialogOnClose = false
    @observable private _isOpen = false

    constructor() {
        makeObservable(this)
    }

    @computed get isOpen(): boolean {
        return this._isOpen
    }

    @computed get canConfirm(): boolean {
        return this.properties.some(bulkProp => bulkProp.isChanged)
    }

    @observable private _title = ''
    @computed get title(): string {
        return this._title
    }

    @observable private _properties: BulkEditPropertyProps[] = []
    @computed get properties(): BulkEditPropertyProps[] {
        return this._properties
    }

    private onBulkEditConfirmCompleted?: (state: BulkEditDialogState) => void
    private onCancel?: (state: BulkEditDialogState) => void

    @action.bound
    public initAndOpen(
        title: string,
        properties: BulkEditPropertyProps[],
        onBulkEditConfirmCompleted?: (state: BulkEditDialogState) => void,
        onCancel?: (state: BulkEditDialogState) => void
    ): void {
        if (onBulkEditConfirmCompleted !== undefined) {
            this.onBulkEditConfirmCompleted = onBulkEditConfirmCompleted
        }

        if (onCancel !== undefined) {
            this.onCancel = onCancel
        }

        this._title = title
        this._properties = properties
        this._isOpen = true
        this.dialogOnClose = false
    }

    @action.bound
    public confirm(): void {
        transaction(() => {
            this.properties
                .filter(property => property.isVisible && property.isChanged)
                .forEach(property => property.applyValue())
        })
        if (this.onBulkEditConfirmCompleted !== undefined) {
            this.onBulkEditConfirmCompleted(this)
        }

        this._isOpen = false
    }

    @action.bound
    public cancel(): void {
        this._isOpen = false

        if (this.onCancel !== undefined) {
            this.onCancel(this)
        }
    }
}
